module.exports = __webpack_public_path__ + "static/media/miri-logo.9005db85.png";